module.exports = __webpack_public_path__ + "Flag-776.f7ba62e14456adaa87ed3414ac979590.svg";